import { FileSystemAdapter } from './file-system-adapter';
import { snapshotManager } from './snapshot-manager';
import { workbenchStore } from '~/lib/stores/workbench';

const fs = new FileSystemAdapter();

export function checkoutPreviousVersion(messageId: string) {
  const files = workbenchStore.files.get();

  return snapshotManager.checkout(messageId, files, fs);
}
